export default "__VITE_ASSET__cc2b7f3a__"